import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import Key from './Key';

export default class Keyboard extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y, forceShowKeys)
    {
        super(scene, x, y);

        this.scene.add.existing(this);

        this.isActive = false;
        this.keySizeHeight = 80;
        this.keySizeWidth = 62;
        this.keySpacing = 12;

        this.mobileKeys = (gameData.isMobile || forceShowKeys) ? true : false;

        this.y = this.scene.scale.height;

        this.codes = [
            { code: 32, key: "space" },
            { code: 65, key: "a" },
            { code: 66, key: "b" },
            { code: 67, key: "c" },
            { code: 68, key: "d" },
            { code: 69, key: "e" },
            { code: 70, key: "f" },
            { code: 71, key: "g" },
            { code: 72, key: "h" },
            { code: 73, key: "i" },
            { code: 74, key: "j" },
            { code: 75, key: "k" },
            { code: 76, key: "l" },
            { code: 77, key: "m" },
            { code: 78, key: "n" },
            { code: 79, key: "o" },
            { code: 80, key: "p" },
            { code: 81, key: "q" },
            { code: 82, key: "r" },
            { code: 83, key: "s" },
            { code: 84, key: "t" },
            { code: 85, key: "u" },
            { code: 86, key: "v" },
            { code: 87, key: "w" },
            { code: 88, key: "x" },
            { code: 89, key: "y" },
            { code: 90, key: "z" },
            { code: 48, key: "0" },
            { code: 49, key: "1" },
            { code: 50, key: "2" },
            { code: 51, key: "3" },
            { code: 52, key: "4" },
            { code: 53, key: "5" },
            { code: 54, key: "6" },
            { code: 55, key: "7" },
            { code: 56, key: "8" },
            { code: 57, key: "9" },
            { code: 20, key: "caps lock" },
            { code: 189, key: "-" },
            { code: 173, key: "-" },
            { code: 187, key: "=" },
            { code: 8, key: "delete" },
            { code: 219, key: "[" },
            { code: 221, key: "]" },
            { code: 220, key: "\\" },
            { code: 90, key: ";" },
            { code: 220, key: "'" },
            { code: 13, key: "enter" },
            { code: 188, key: "," },
            { code: 190, key: "." },
            { code: 191, key: "/" },
            { code: 16, key: "shift" }
        ];
        this.downCodes = [];

        this.initKeys();
    }

    initKeys()
    {
        //add touch handle to keys for mobile
        if (this.mobileKeys)
        {
            let secondRow = this.createRow(["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"]);
            let midRow = this.createRow(["a", "s", "d", "f", "g", "h", "j", "k", "l"]);
            let bottomRow = this.createRow(["z", "x", "c", "v", "b", "n", "m"]);
            this.keys = [secondRow, midRow, bottomRow];
            this.positionKeys();
        }

        this.scene.input.keyboard.on(Phaser.Input.Keyboard.Events.ANY_KEY_DOWN, e => this.handleKeyPress(e), this);
        this.scene.input.keyboard.on(Phaser.Input.Keyboard.Events.ANY_KEY_UP, e => this.handleKeyUp(e), this);

        this.isActive = true;
    }

    positionKeys()
    {
        for (let i = 0; i < this.keys.length; i++)
        {
            let row = this.keys[i];
            let rowWidth = (row.length * (this.keySizeWidth + this.keySpacing)) - this.keySpacing;
            let rowStart = -(rowWidth / 2);

            let rowY = i * (this.keySizeHeight + (this.keySpacing * 2));
            for (let j = 0; j < row.length; j++)
            {
                let key = row[j];
                key.endX = (j == 0) ? rowStart : row[j - 1].endX + row[j - 1].keyWidth + this.keySpacing;
                key.endY = rowY;
                key.x = key.endX;
                key.y = key.endY;
                this.add(key);
            }
        }
    }

    handleKeyPress(key)
    {
        if (this.isActive == true)
        {
            let keyPressed = key.keyValue ? key : null;
            let keyId;
            let keyVal;
            //exit out of both virtual and real keyboards if key press already triggered
            if ((keyPressed && keyPressed.isDown == true) || !keyPressed && this.downCodes.indexOf(key.keyCode) != -1) return;

            //show key up state in virtual keyboard
            if (keyPressed)
            {
                if (keyPressed.isDown == false) keyPressed.showKeyPress(true);
                keyId = keyPressed.keyId;
                keyVal = keyPressed.keyValue
            }
            else
            {
                keyId = this.findKeyByCode(key.keyCode) + "_key";
                keyVal = this.findKeyByCode(key.keyCode);
                this.downCodes.push(key.keyCode);
            }

            let event = { _keyId: keyId, _keyValue: keyVal };
            //pass key id with value to detect which shift is detected
            if (event._keyValue == "SPACE" || event._keyValue == "space") event._keyValue = " ";

            this.emit("KEY_PRESS", event);
        }
    }

    handleKeyUp(key)
    {
        let keyPressed = key.keyValue ? key : null;
        if (keyPressed)
        {
            if (keyPressed.keyValue != "caps lock") keyPressed.showKeyPress(false);
        }
        else
        {
            this.downCodes.splice(this.downCodes.indexOf(key.keyCode), 1);
        }
    }

    createRow(keys)
    {
        let row = [];
        while (row.length < keys.length)
        {
            let key = new Key(this.scene, 0, 0, keys[row.length], this.keySizeWidth, this.keySizeHeight);
            key.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.handleKeyPress(key));
            key.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, () => this.handleKeyUp(key));
            key.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, () => this.handleKeyUp(key));
            row.push(key);
        }
        return row;
    }

    controlKeysShown(showFlag)
    {
        if (!this.mobileKeys) return;

        if (showFlag == true)
        {
            this.isActive = true;
            if (!gameData.isMobile)
            {
                ABCyaPhaser.Tweens.addTween(this, 500, { y: this.scene.scale.height - ((this.keySizeHeight + (this.keySpacing * 2)) * this.keys.length) - 40 }, Phaser.Math.Easing.Quadratic.In);
            }
            else
            {
                ABCyaPhaser.Tweens.addTween(this, 500, { y: this.scene.scale.height - ((this.keySizeHeight + (this.keySpacing * 2)) * this.keys.length) - 20 }, Phaser.Math.Easing.Quadratic.In);
            }
        }
        else
        {
            this.isActive = false;
            ABCyaPhaser.Tweens.addTween(this, 500, { y: this.scene.scale.height }, Phaser.Math.Easing.Quadratic.Out);
        }
    }

    getKeyByValue(val)
    {
        let key;
        for (let i = 0; i < this.keys.length; i++)
        {
            for (let j = 0; j < this.keys[i].length; j++)
            {
                if (this.keys[i][j].keyValue == val)
                {
                    key = this.keys[i][j];
                    break;
                }
            }

            if (key != null) break;
        }

        return key;
    }

    findKeyById(id)
    {
        let keyFound = null;
        for (let i = 0; i < this.keys.length; i++)
        {
            let row = this.keys[i];
            for (let j = 0; j < row.length; j++)
            {
                if (row[j].keyId == id)
                {
                    keyFound = row[j];
                    break;
                }
            }

            if (keyFound != null)
            {
                break;
            }
        }

        return keyFound;
    }

    findKeyByCode(code)
    {
        let i = 0;
        let key = null;
        while (i < this.codes.length && key == null)
        {
            if (this.codes[i]["code"] == code)
            {
                //get both shift keys for shift???
                let keyString = this.codes[i]['key'];
                key = keyString;
            }
            i++;
        }

        return key;
    }
}